import React, { Children, useState } from "react";

import {
  Box,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  ListSubheader,
  TextField,
  InputAdornment,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

// import JS files
import MuiTheme from "./MuiTheme";
import { fixNumbers } from "../../utils";

// import Others files

const MuiComboBox = ({
  label,
  options,
  forProvider,
  placeholder,
  setSelectedOption,
  setSearchText,
  size,
  labelId,
  id,
  forUser,
  baseUsername,
  setSelectedUser,
  haveSetSelectedUser,
  baseWithJustUser,
  selectedOption,
}) => {
  let windowWidth = window.screen.width;

  const handleSelected = (e) => {
    setSelectedOption(e.target.value);

    if (haveSetSelectedUser) {
      setSelectedUser(options.filter((it) => it.username == e.target.value)[0]);
    }
    if (baseWithJustUser) {
      setSelectedUser(options.filter((it) => it.user == e.target.value)[0]);
    }
  };

  return (
    <>
      <MuiTheme>
        <FormControl fullWidth size={size}>
          <InputLabel id={labelId}>{label}</InputLabel>
          <Select
            MenuProps={{ autoFocus: false }}
            labelId={labelId}
            id={id}
            // value={}
            defaultValue={selectedOption}
            label="Options"
            onChange={(e) => handleSelected(e)}
            onClose={() => setSearchText("")}
            //   renderValue={() => selectedOption}
          >
            <ListSubheader>
              <TextField
                size="small"
                autoFocus
                placeholder={placeholder}
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                }}
                onChange={(e) => setSearchText(fixNumbers(e.target.value))}
                onKeyDown={(e) => {
                  if (e.key !== "Escape") {
                    e.stopPropagation();
                  }
                }}
              />
            </ListSubheader>
            {options.map((option, i) => (
              <MenuItem
                key={i}
                value={
                  baseUsername
                    ? option.username
                    : baseWithJustUser
                    ? option.user
                    : option.id
                }
              >
                {forProvider ? (
                  option.check_need_order ? (
                    option.name + " " + "- نیاز به سفارش"
                  ) : (
                    option.name
                  )
                ) : forUser ? (
                  option.name
                ) : (
                  <span>
                    {option.code}-{option.show_name}-{option.brand_name}-
                    {option.color == "yellow" ? "زرد" : "سفید"}-
                    {option.gender == "woman" ? "زنانه" : "بچگانه"}
                  </span>
                )}
                {}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </MuiTheme>
    </>
  );
};

export default MuiComboBox;
